export const heroStats = [
  { id: 1, label: '今日热议话题', value: '128' },
  { id: 2, label: '同时在线瓜友', value: '5,240' },
  { id: 3, label: '新增讨论留言', value: '1,286' },
];

export const trendingTopics = [
  {
    id: 1,
    rank: 1,
    title: '新剧开播三天口碑反转，主创团队深夜回应争议',
    category: '影视综艺',
    heat: '86.4万',
    summary: '开播前的期待与播出后的讨论形成鲜明对比，网友整理出三条最集中的意见。',
    isNew: true,
  },
  {
    id: 2,
    rank: 2,
    title: '音乐节现场视频流出，退场秩序成瓜友关注焦点',
    category: '音乐现场',
    heat: '72.1万',
    summary: '一段现场画面在短时间被大量转发，主办方随后公布了分流方案。',
    isNew: true,
  },
  {
    id: 3,
    rank: 3,
    title: '综艺录制路透曝光，嘉宾阵容引发新一轮猜测',
    category: '娱乐八卦',
    heat: '65.7万',
    summary: '路透图中的细节被瓜友逐帧分析，节目组暂未公布正式名单。',
  },
  {
    id: 4,
    rank: 4,
    title: '博主带货选品争议持续，评论区晒出对比记录',
    category: '网红动态',
    heat: '54.3万',
    summary: '多位瓜友贴出同款商品的价格对比，讨论逐渐转向选品标准本身。',
  },
  {
    id: 5,
    rank: 5,
    title: '时装周造型盘点，这套搭配被瓜友投票评为最佳',
    category: '时尚潮流',
    heat: '41.9万',
    summary: '造型盘点贴收获大量互动，评论区自发做起了投票统计。',
  },
  {
    id: 6,
    rank: 6,
    title: '赛后采访一句话上热搜，球迷开始翻旧账',
    category: '体育花边',
    heat: '33.6万',
    summary: '采访片段被反复传播，球迷把两队历史交手的记录也整理了出来。',
  },
  {
    id: 7,
    rank: 7,
    title: '老牌组合疑似合体，歌单截图被瓜友发现端倪',
    category: '音乐现场',
    heat: '27.2万',
    summary: '一张彩排歌单截图引发合体猜想，粉丝在评论区列起了愿望曲目。',
  },
  {
    id: 8,
    rank: 8,
    title: '短剧市场新爆款出炉，剧情节奏被反复讨论',
    category: '影视综艺',
    heat: '19.8万',
    summary: '短短几分钟一集的节奏成了讨论重点，有人夸紧凑也有人嫌太快。',
  },
];

export const topicCategories = [
  {
    id: 'entertainment',
    name: '娱乐八卦',
    icon: 'ri-fire-line',
    count: 326,
    description: '从官宣到辟谣，热点脉络一次理清，瓜友各抒己见。',
  },
  {
    id: 'screen',
    name: '影视综艺',
    icon: 'ri-film-line',
    count: 268,
    description: '剧集综艺播出动态、口碑变化与幕后讨论都在这里。',
  },
  {
    id: 'influencer',
    name: '网红动态',
    icon: 'ri-live-line',
    count: 194,
    description: '直播间与短视频里的新鲜事，瓜友第一时间同步。',
  },
  {
    id: 'music',
    name: '音乐现场',
    icon: 'ri-music-2-line',
    count: 152,
    description: '演唱会、音乐节现场见闻与歌单分享的交流角。',
  },
  {
    id: 'fashion',
    name: '时尚潮流',
    icon: 'ri-t-shirt-line',
    count: 121,
    description: '红毯造型、时尚活动与穿搭话题的集中讨论区。',
  },
  {
    id: 'sports',
    name: '体育花边',
    icon: 'ri-basketball-line',
    count: 96,
    description: '赛场之外的花絮与话题，球迷瓜友都能聊两句。',
  },
];

export const articles = [
  {
    id: 1,
    title: '开播三天口碑反转：这部新剧到底哪一步走错了',
    excerpt: '我们把瓜友讨论里出现频率最高的三条意见整理出来，逐条对照剧集节奏，看看争议究竟出在哪里。',
    category: '影视综艺',
    author: '瓜田小队长',
    date: '2026-09-10',
    readTime: '6 分钟',
    image: 'https://readdy.ai/api/search-image?query=stylized%20editorial%20illustration%20of%20a%20stage%20spotlight%20over%20an%20empty%20microphone%2C%20warm%20coral%20and%20amber%20palette%2C%20minimal%20clean%20cream%20background%2C%20magazine%20cover%20aesthetic%2C%20soft%20gradients&width=800&height=600&seq=hcg-art-01&orientation=landscape',
    tag: '热剧',
  },
  {
    id: 2,
    title: '音乐节散场混乱刷屏，主办方分流方案能救场吗',
    excerpt: '现场视频流出后，争议从秩序问题延伸到票务与场地容量。我们梳理了时间线，也收集了不同的声音。',
    category: '音乐现场',
    author: '前排吃瓜',
    date: '2026-09-09',
    readTime: '5 分钟',
    image: 'https://readdy.ai/api/search-image?query=stylized%20illustration%20of%20concert%20stage%20lights%20and%20headphones%2C%20warm%20amber%20coral%20tones%2C%20minimal%20cream%20background%2C%20editorial%20magazine%20aesthetic%2C%20soft%20glow&width=800&height=600&seq=hcg-art-02&orientation=landscape',
    tag: '现场',
  },
  {
    id: 3,
    title: '带货选品争议升级：瓜友晒出的对比表说明了什么',
    excerpt: '一份由瓜友自发整理的对比表在社区流传，我们核对了公开信息，也提醒大家理性看待价格差异。',
    category: '网红动态',
    author: '理智瓜子',
    date: '2026-09-09',
    readTime: '7 分钟',
    image: 'https://readdy.ai/api/search-image?query=stylized%20illustration%20of%20a%20glowing%20smartphone%20with%20notification%20bubbles%2C%20warm%20coral%20and%20gold%20palette%2C%20minimal%20cream%20background%2C%20editorial%20content%20style%2C%20soft%20gradients&width=800&height=600&seq=hcg-art-03&orientation=landscape',
    tag: '争议',
  },
  {
    id: 4,
    title: '综艺录制路透不断流出，节目组为何迟迟不官宣',
    excerpt: '路透越多猜测越多，我们回顾了往季的官宣节奏，从流程角度解释为什么名单总是最后一步才公布。',
    category: '影视综艺',
    author: '综艺观察员',
    date: '2026-09-08',
    readTime: '4 分钟',
    image: 'https://readdy.ai/api/search-image?query=stylized%20flat%20illustration%20of%20a%20retro%20television%20set%20and%20film%20reel%2C%20warm%20coral%20amber%20color%20scheme%2C%20minimal%20cream%20backdrop%2C%20editorial%20magazine%20style%2C%20soft%20shadows&width=800&height=600&seq=hcg-art-04&orientation=landscape',
    tag: '路透',
  },
  {
    id: 5,
    title: '时装周造型投票出炉：票选第一的搭配赢在哪几处',
    excerpt: '社区发起的造型投票已经有了结果，我们拆解了前三名的搭配逻辑，看看瓜友的审美偏好。',
    category: '时尚潮流',
    author: '瓜子时尚',
    date: '2026-09-08',
    readTime: '5 分钟',
    image: 'https://readdy.ai/api/search-image?query=stylized%20illustration%20of%20a%20fashion%20runway%20silhouette%20with%20hangers%2C%20warm%20coral%20gold%20palette%2C%20minimal%20cream%20backdrop%2C%20editorial%20style%2C%20elegant%20composition&width=800&height=600&seq=hcg-art-05&orientation=landscape',
    tag: '造型',
  },
  {
    id: 6,
    title: '赛后一句话冲上热搜，两队历史交手记录被翻出',
    excerpt: '一句采访发言带火了整场讨论，我们把两队近年交手的公开记录整理成表，方便瓜友对照着聊。',
    category: '体育花边',
    author: '场边吃瓜',
    date: '2026-09-07',
    readTime: '6 分钟',
    image: 'https://readdy.ai/api/search-image?query=stylized%20illustration%20of%20a%20stadium%20and%20football%2C%20warm%20amber%20coral%20palette%2C%20minimal%20cream%20background%2C%20editorial%20magazine%20style%2C%20soft%20gradient&width=800&height=600&seq=hcg-art-06&orientation=landscape',
    tag: '热搜',
  },
];

export const communityVoices = [
  {
    id: 1,
    name: '深夜刷瓜',
    role: '资深瓜友',
    avatar: '夜',
    content: '最舒服的是这里会先把时间线理清楚，不用自己一页页翻。看完再进讨论区，聊起来心里有底，不会被带偏。',
    topic: '影视综艺',
    likes: 328,
  },
  {
    id: 2,
    name: '柠檬不加冰',
    role: '话题发起人',
    avatar: '柠',
    content: '我发的话题经常有瓜友补充细节，评论区比正文还热闹。大家各说各的，但很少对线，氛围确实挺好。',
    topic: '娱乐八卦',
    likes: 256,
  },
  {
    id: 3,
    name: '前排小板凳',
    role: '社区活跃用户',
    avatar: '前',
    content: '榜单更新挺快，早上刷和晚上刷看到的热点不一样。分类也做得细，找某个方向的瓜比以前方便很多。',
    topic: '网红动态',
    likes: 187,
  },
  {
    id: 4,
    name: '瓜田守夜人',
    role: '内容纠错志愿者',
    avatar: '守',
    content: '有些消息真假难辨，这里会标注信息来源，也允许大家提出疑问。至少不会被一句话就带着跑，这点很难得。',
    topic: '音乐现场',
    likes: 142,
  },
];

export const faqs = [
  {
    id: 1,
    question: '黑吃瓜网主要提供哪些内容？',
    answer:
      '黑吃瓜网聚合今日热议话题、娱乐瓜料与话题分类。你可以在同一处浏览热点榜单、阅读整理好的内容，并在瓜友交流区参与讨论，不用在多个平台之间来回切换。',
  },
  {
    id: 2,
    question: '网站上的话题是怎么排序的？',
    answer:
      '热议榜单综合话题的讨论量、阅读量与瓜友互动情况排序，热度实时变化。越多人参与的话题越容易出现在靠前的位置，因此早上和晚上看到的榜单可能会有明显不同。',
  },
  {
    id: 3,
    question: '我可以参与话题讨论吗？',
    answer:
      '可以。每个话题都设有讨论入口，你可以在瓜友交流区发表观点、补充线索，和其他吃瓜群众一起把话题聊透。发布内容前请遵守社区约定，理性表达、尊重他人。',
  },
  {
    id: 4,
    question: '如何判断站内内容是否可靠？',
    answer:
      '我们会尽量标注信息来源与发布时间，对于尚未确认的消息会明确写出「待核实」。也欢迎你在评论区提出疑问，纠错志愿者的反馈会被优先处理。',
  },
  {
    id: 5,
    question: '怎样订阅最新话题更新？',
    answer:
      '在页面底部填写邮箱即可订阅。我们会按你关注的分类，把当天讨论度较高的话题整理成一封简短的推送，频率通常为一天一次。',
  },
];